import { render, staticRenderFns } from "./RefPrioritiesList.vue?vue&type=template&id=d9d9991a&scoped=true"
import script from "./RefPrioritiesList.vue?vue&type=script&lang=js"
export * from "./RefPrioritiesList.vue?vue&type=script&lang=js"
import style0 from "./RefPrioritiesList.vue?vue&type=style&index=0&id=d9d9991a&prod&lang=scss&scoped=true"
import style1 from "./RefPrioritiesList.vue?vue&type=style&index=1&id=d9d9991a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d9991a",
  null
  
)

export default component.exports